module.exports = __webpack_public_path__ + "img/twitter.d457cdc6.svg";